<template>
    <div id="asses-table">
        <!-- 导出 excel-->
        <el-button
                size="small"
                type="info"
                style="margin-top: -42px;display: inline-block;position: absolute;right: 85px"
                @click="download"
                :disabled="userInfo.disabled"
        >
            {{ this.$t('common.download') }}
        </el-button>
        <a
                id="a-download"
                style="visibility:hidden "
        />
        <el-table
                @sort-change="sortChange"
                id="asses-table-list"
                v-loading="loadingData"
                :data="getTableData"
                :span-method="spanMethod"
                :header-cell-style="{textAlign:'center'}"
        >
            <el-table-column
                    :label="$t('table.index')"
                    prop="customIndex"
                    align="center"
                    :width="getLocales === 'en' ? 60 : 50 "
            />
            <el-table-column
                    :label="$t('jobInfo.locationOrArea')"
                    prop="locationOrArea"
                    align="center"
                    :min-width="getLocales === 'en' ? 120 : 100"
            />
            <el-table-column
                    :label="$t('jobInfo.departmentOrLine')"
                    prop="departmentOrLine"
                    align="center"
                    :min-width="120"
            />
            <el-table-column
                    :label="$t('jobInfo.job')"
                    prop="job"
                    align="center"
                    width="120"
            />
            <el-table-column
                    :label="$t('jobInfo.riskLevel')"
                    prop="riskLevel"
                    align="center"
                    :width="getLocales === 'en' ? 160 : 120 "
            >
                <template slot="header" slot-scope="scope">
                   <div  @click="sortChange" class="sort-order-container">
                       <span>{{ $t('jobInfo.riskLevel') }}</span>
                       <span class="risk-level-sort">
                    <i class="el-icon-caret-top" :class="[sortCount === 2 ? 'is-active': '']"></i>
                    <i class="el-icon-caret-bottom" :class="[sortCount === 1 ? 'is-active': '']"></i>
                    </span>
                   </div>
                </template>
                <template slot-scope="scope">
                    <el-tag
                            :type="riskRankTypeMap[scope.row.riskLevel]"
                    >
                        {{ $t(`riskLevel.${scope.row.riskLevel}`) }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column
                    :label="$t('common.stage')"
                    prop="stage"
                    align="center"
                    width="90px"
            >
                <template slot-scope="scope">
                    <span>{{ $t(scope.row.stage ) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    :label="$t('common.date')"
                    width="100"
                    align="center"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.stageCode === 'before' ? scope.row.firstDate : scope.row.secondDate }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    :label="$t('menu.factor')"
                    label-class-name="factor-header"
                    align="center"
            >
                <el-table-column
                        :label="$t('common.total')"
                        prop="totalRiskFactors"
                        align="center"
                />
            </el-table-column>
            <el-table-column
                    :label="$t('menu.analysis')"
                    label-class-name="analysis-header"
                    align="center"
            >
                <el-table-column
                        :label="$t('ergoRisk.totalOfHAVH')"
                        prop="totalWithHighAndVeryHigh"
                        align="center"
                        :width="getLocales === 'en' ? 100 : 80"
                />
                <el-table-column
                        :label="$t('common.bodyPart')"
                        prop="bodyPart"
                        show-overflow-tooltip
                        align="center"
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.bodyPart.map(b => { return $t(b) }).join(',') }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column
                    :label="$t('menu.manual')"
                    label-class-name="manual-header"
                    align="center"
            >
                <el-table-column
                        :label="$t('manualTool.RWL')"
                        prop="rwl"
                        align="center"
                        width="105"
                />
                <el-table-column
                        :label="$t('manualTool.liftingIndex')"
                        prop="liftingIndex"
                        align="center"
                        width="80"
                />
            </el-table-column>
            <el-table-column
                    v-if="showOperate"
                    :label="$t('table.operate')"
                    width="160px"
                    fixed="right"
                    align="right"
            >
                <template slot-scope="scope">
                    <el-button
                            type="warning"
                            size="small"
                            @click="deleteItem(scope.row)"
                    >
                        {{ $t('table.delete') }}
                    </el-button>
                    <el-button
                            type="primary"
                            size="small"
                            @click="edit(scope.row)"
                    >
                        {{ $t('table.edit') }}
                    </el-button>
                </template>
            </el-table-column>
            <div
                    v-if="getTableData.length > 0"
                    slot="append"
            >
                <el-pagination
                        :current-page="filterPage+1"
                        :page-sizes="[10, 15, 20, 30, 40]"
                        :page-size="filterPageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="filterTotal"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                />
            </div>
        </el-table>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapGetters, mapActions} from 'vuex'

    export default {
        name: "AssesTable",
        components: {},
        data() {
            return {
                showOperate: true,
                loadingData: false,
                tableData: [],
                tableIndex: 1,
                allTableData: [],
                filterItem: {
                    keywords: '',
                    page: 0,
                    pageSize: 15,
                    lastPage: 0,
                    total: 0,
                    creator: '',
                },
                riskRankTypeMap: {
                    9: 'danger',
                    3: 'warning',
                    1: 'success',
                },
                hasSpannedRows: [],
                json_fields: {
                    [this.$t('jobInfo.locationOrArea')]: "locationOrArea",
                    [this.$t('jobInfo.departmentOrLine')]: "departmentOrLine",
                    [this.$t('jobInfo.job')]: "job",
                    [this.$t('jobInfo.riskLevel')]: "riskLevel",
                    [this.$t('common.stage')]: "stage",
                    [this.$t('menu.factor') + '-' + this.$t('menu.factor')]: "factor",
                    [this.$t('menu.analysis') + '-' + this.$t('ergoRisk.totalOfHAVH')]: "totalOfHAVH",
                    [this.$t('menu.analysis') + '-' + this.$t('common.bodyPart')]: "bodyPart",
                    [this.$t('menu.manual') + '-' + this.$t('manualTool.RWL')]: "rwl",
                    [this.$t('menu.manual') + '-' + this.$t('manualTool.liftingIndex')]: "liftingIndex",

                },
                sortCount: 0,
                sortCountMap: {
                    0: '',
                    1: 'descending',
                    2: 'ascending'
                },
            }
        },
        computed: {
            ...mapState(["filterPage", "filterPageSize", "filterTotal", "ergoRiskMatrixes", "sequenceFilter", 'userInfo']),
            ...mapGetters(["getTableData", "getSequenceFilter", "getLocales"])
        },
        mounted() {
            let email = this.$route.query.email
            if (!email) {
                email = this.userInfo.email
            }
            this.$store.commit('setUserToQuery', email)

            this.retrieveErgoRiskMatrixByUser(this)

            this.setFilterPageSize(15);
            this.setFilterPage(0);

            // if (this.$route.query.from === 'create') {
            //     this.$router.replace({name: 'home'})
            //     window.location.reload()
            // }
        },
        methods: {
            ...mapMutations(["setFilterPage", "setFilterPageSize"]),
            ...mapActions(["retrieveErgoRiskMatrixByUser"]),
            edit(row) {
                let ergoRiskMatrix = this.ergoRiskMatrixes.filter(item => item.id === row.assessId)[0];
                // 进入编辑，构造 ergoMatrixes 中 assessment中第二次评估
                this.$store.commit('newErgoRiskMatrix', ergoRiskMatrix);
                if (this.$store.state.ergoRiskMatrix.assessments.length === 1) {
                    this.$store.commit('pushNewAssessment', 2);
                }
                this.$router.push({name: 'create-assess', query: {id: row.id}});
            },
            spanMethod({row, columnIndex}) {
                if (this.sequenceFilter) return;
                if (columnIndex < 5) {
                    if (row.asssessTimes > 1 && row.stageCode === 'before') {
                        return [row.asssessTimes, 1];
                    }
                    if (row.asssessTimes > 1 && row.stageCode === 'after') {
                        return [0, 0];
                    }
                }
                if (columnIndex === 12 && row.asssessTimes > 1) {
                    if (row.stageCode === 'before') {
                        return [row.asssessTimes, 1];
                    } else {
                        return [0, 0];
                    }
                }
            },
            deleteItem(row) {
                this.$confirm(this.$t('tips.deleteTip'), this.$t('common.delete'), {
                    confirmButtonText: this.$t('common.confirm'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: 'warning'
                }).then(async () => {
                    await (new this.$swagger.ErgoriskmatrixcontrollerApi()).deleteErgoRiskMatrix(row.assessId);
                    this.$message({
                        type: 'success',
                        message: this.$t('tips.operateSuccess')
                    });
                    this.getErgoRiskMatrixes();
                }).catch(() => {
                    this.$notify.warning(this.$t('tips.requestFail'))
                });

            },
            async getErgoRiskMatrixes() {
                this.loadingData = true;
                await this.retrieveErgoRiskMatrixByUser(this);
                this.loadingData = false;
            },
            //    分页
            async handleSizeChange(size) {
                this.setFilterPageSize(size);
                await this.$store.dispatch('retrieveErgoRiskMatrixByUser', this);
            },
            handleCurrentChange(page) {
                this.setFilterPage(page - 1);
            },
            async download() {
                this.loadingData = true;
                this.showOperate = false;
                this.setFilterPageSize(10000);
                await this.$store.dispatch('retrieveErgoRiskMatrixByUser', this);
                this.$nextTick(async function () {
                    const headerTable = document.getElementsByClassName('el-table__header')[0].outerHTML;
                    const bodyTable = document.getElementsByClassName('el-table__body')[0].outerHTML;
                    // 使用outerHTML属性获取整个table元素的HTML代码（包括<table>标签），然后包装成一个完整的HTML文档，设置charset为urf-8以防止中文乱码
                    let html = "<html lang='en'><head><meta charset='utf-8' /><style>tr {text-align: center; line-height: 10px}</style><title>Ergo</title></head><body>" + headerTable + bodyTable + "</body></html>";
                    // 实例化一个Blob对象，其构造函数的第一个参数是包含文件内容的数组，第二个参数是包含文件类型属性的对象
                    const blob = new Blob([html], {type: "application/vnd.ms-excel"});
                    const a = document.getElementById("a-download");
                    // 利用URL.createObjectURL()方法为a元素生成blob URL
                    a.href = URL.createObjectURL(blob);
                    // 设置文件名
                    a.download = this.$t('download.download') + '.xls';
                    a.click();
                    this.showOperate = true;
                    this.setFilterPageSize(15);
                    this.loadingData = false;
                })

            },

            sortChange() {
                this.sortCount ++
                this.$store.commit('setFilterSortType', this.sortCountMap[this.sortCount])
                if (this.sortCount > 2) {
                    this.sortCount = 0
                }
                // return (`${this.jobInfo.locationOrArea}`)
            }
        }
    }
</script>

<style lang="scss">
    tbody tr {
        border: 1px solid #f2f2f2;
    }

    #asses-table {

        .sort-order-container {
            :hover {
                cursor: pointer;
            }
            .risk-level-sort {
                width: 14px;
                display: inline-block;
                height: 30px;
                /*margin-top: 10px;*/
                position: relative;
                margin-bottom: -13px;
                margin-left: 5px;
                .is-active {
                    color: #409EFF;
                }
                i {
                    position: absolute;
                    left: 0px;
                }

                i:nth-child(2) {
                    bottom: 5px;
                }
            }

        }
        /*.sort-caret {*/
        /*  border-bottom-color: wheat;*/
        /*}*/
        .factor-header {
            height: 100%;
            width: 100%;
            display: inline-block;
            background-color: #409EFF;
            /*color: #409EFF;*/
        }

        .manual-header {
            /*color: #4caf50;*/
        }

        .analysis-header {
            /*color: #00bcd4;*/
        }

        .el-table__header tr:nth-child(1) th {
            background-color: #C0C4CC;
            color: #FFFFFF;
        }

        .el-table__header tr:nth-child(1) {
            th:nth-child(8) {
                background-color: #409EFF;
                color: #FFFFFF;
            }

            th:nth-child(9) {
                background-color: #4caf50;
                color: #FFFFFF;
            }

            th:nth-child(10) {
                background-color: #00bcd4;
                color: #FFFFFF;
            }
        }

        .el-table__header tr:nth-child(2) {
            th:nth-child(1) {
                background-color: #409EFF;
                color: #FFFFFF;
            }

            th:nth-child(2), th:nth-child(3) {
                background-color: #4caf50;
                color: #FFFFFF;
            }

            th:nth-child(4), th:nth-child(5) {
                background-color: #00bcd4;
                color: #FFFFFF;
            }
        }
    }
</style>
